import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material'
import React, { useContext } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import styles from '../../../assets/styles/componentStyles/getStartedStyles/getStartedStyles.module.scss';
import StatCard from './components/statCard';
import FeatureCard from './components/featureCard';
import Footer from './components/footer';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getVendorCompanyName } from '../../../utils/constants';


const GetStartedGlobal = () => {

    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const innerHeight = window.innerHeight; 
    const mobileInnerHeight = window.innerHeight - 80;

    const { vendorData } = useContext(UserContext) as UserContextPayload;

    const companyName = getVendorCompanyName(vendorData);
        
    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`} sx={{display: "flex", justifyContent: "center", height: "100vh", alignItems: "center"}}>
                {/* <Grid container className={`${styles.getStartedPage} ${globalStyles.overflowAuto} ${globalStyles.justifyCenter}`} sx={{ padding: { xs: "15px 0px", sm: "12px 0px"}, maxHeight: `${smallScreen && mobileInnerHeight}px !important`, margin: "auto !important" }} direction={"column"} flexWrap={"nowrap"}> */}
                <Grid container className={`${styles.getStartedPage} ${globalStyles.overflowAuto} ${globalStyles.justifyCenter}`} sx={{ padding: { xs: "15px 0px", sm: "12px 0px"}, margin: "auto !important" }} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12} className={styles.getStartedContentWrapepr}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={globalStyles.fullwidth} sx={{ padding: { xs: "0px 20px", lg: "5px 25px 0px 27px" } }}>
                                <Box className={styles.getStartedHeaderTextWrapper}>
                                    <Box className={styles.getStartedHeaderText}>
                                        <Typography variant='h5' className={styles.oneStopSolutionTitle}>
                                            <Typography component="span" variant='h5' className={`${styles.oneStopSolutionTitle} ${globalStyles.primaryColor}`}>
                                                Welcome to {companyName}
                                            </Typography>
                                            {" "} - How Would You Like to Get Started?
                                        </Typography>
                                    </Box>
                                    {/* <Box>
                                        <Typography  className={globalStyles.geStartedPageDescription} >
                                            Engage with your audience using powerful tools like WhatsApp Campaigns, AI Chatbots, and Rule-Based Chatbots.
                                        </Typography>
                                        <Typography  className={globalStyles.geStartedPageDescription}>
                                            Automate interactions across your preferred platforms.
                                        </Typography>
                                    </Box> */}
                                </Box>
                                {/* <StatCard/> */}
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle}`} sx={{ paddingTop: "20px !important" }} />}
                                <FeatureCard />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} >
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={globalStyles.fullwidth} sx={{ padding: { xs: "0px 15px", lg: "5px 12px 0px 17px" } }}>
                                <Footer/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default GetStartedGlobal
